<template>
<div class="chapter">
<div class="inner_page">
<a id="page_xiii">
<h2 class="sec_front">Maps</h2>
</a><p class="noindent"><a id="page_xiii"></a><a href="#/xhtml/#map2">Maps 2</a>–<a href="#/xhtml/#map10">10</a> portray the course of a great battle pictorially. They are not the products of postwar fantasy, but were made in 1944 during the fighting itself.</p>
<p class="indent">In order to present graphically the situation at the time, the groupings of both sides are shown simultaneously.</p>
<p class="indent">Knowledge as to the enemy’s groupings and his intentions, as the maps show, are naturally known best at the end of a phase of battle of one or several days and not at the beginning. Our own movements were taken without this foreknowledge.</p>
<a id="page_xiv">
<p class="image"><img alt="image" src="images/Img_0xiv-01.jpg"/></p>
<p class="caption">1. Army Group South: Sixth, Eighth, First Panzer, Fourth Panzer Army. Mid-January 1944.</p>
</a><a id="page_xv">
<p class="image" id="map2"><img alt="image" src="images/Img_00xv-01.jpg"/></p>
<p class="caption1">2. Eighth Army in action, 5–7 January 1944</p>
</a><a id="page_xvi">
<p class="image"><img alt="image" src="images/Img_0xvi-01.jpg"/></p>
<p class="caption1">3. Eighth Army in action, 8–10 January 1944</p>
</a><a id="page_xvii">
<p class="image"><img alt="image" src="images/Img_xvii-01.jpg"/></p>
<p class="caption1">4. Eighth Army in action 12–16 January 1944</p>
</a><a id="page_xviii">
<p class="image"><img alt="image" src="images/Img_xviii.jpg"/></p>
<p class="caption1">5. Eighth Army in action 25–28 January 1944</p>
</a><a id="page_xix">
<p class="image"><img alt="image" src="images/Img_0xix-01.jpg"/></p>
<p class="caption1">6. Eighth Army and First Panzer Army in action, 29–31 January 1944</p>
</a><a id="page_xx">
<p class="image"><img alt="image" src="images/Img_00xx-01.jpg"/></p>
<p class="caption1">7. Eighth Army and First Panzer Army in action, 1–5 February 1944</p>
</a><a id="page_xxi">
<p class="image"><img alt="image" src="images/Img_0xxi-01.jpg"/></p>
<p class="caption1">8. Eighth Army and First Panzer Army in action, 6–9 February 1944</p>
</a><a id="page_xxii">
<p class="image"><img alt="image" src="images/Img_xxii-01.jpg"/></p>
<p class="caption1">9. Eighth Army and First Panzer Army in action, 10–13 February 1944</p>
</a><a id="page_xxiii">
<p class="image"><img alt="image" src="images/Img_xxiii-01.jpg"/></p>
<p class="caption1" id="map10">10. Eighth Army and First Panzer Army in action, 14–17 February 1944</p>
</a><a id="page_xxiv">
<p class="image"><img alt="image" src="images/Img_xxiv-01.jpg"/></p>
<p class="caption1">11. Breakout of XI and XXXXII Army Corps at 2300 hrs on 16 February 1944</p>
</a><a id="page_xxv">
<p class="pbk"></p>
<p class="noindent">Place names:</p>
<table>
<tbody><tr>
<td class="tab"><em class="italic">German</em></td>
<td class="tab"><em class="italic">English usage</em></td>
</tr>
<tr>
<td>Adshamka</td>
<td>Adshamka</td>
</tr>
<tr>
<td>Angerburg</td>
<td>Angerburg</td>
</tr>
<tr>
<td>Apostolowa</td>
<td>Apostolev</td>
</tr>
<tr>
<td>Balkan</td>
<td>Balkans</td>
</tr>
<tr>
<td>Bertechsgaden</td>
<td>Berchtesgaden</td>
</tr>
<tr>
<td>Berditschew</td>
<td>Berditschev</td>
</tr>
<tr>
<td>Bielow</td>
<td>Bielov</td>
</tr>
<tr>
<td>Schwarzes Meer</td>
<td>Black Sea</td>
</tr>
<tr>
<td>Bolschaja Wyska</td>
<td>Bolshaya Vyska</td>
</tr>
<tr>
<td>Bojarka</td>
<td>Boyarka</td>
</tr>
<tr>
<td>Brest Litowsk</td>
<td>Brest Litovsk</td>
</tr>
<tr>
<td>Bug</td>
<td>Bug, River</td>
</tr>
<tr>
<td>Buschanka</td>
<td>Bushanka-Kissyanka</td>
</tr>
<tr>
<td>Bjelaja Zarkow</td>
<td>Byelaya Zarkov</td>
</tr>
<tr>
<td>Kaukasus</td>
<td>Caucasus</td>
</tr>
<tr>
<td>Tscherkassy</td>
<td>Cherkassy</td>
</tr>
<tr>
<td>Cherson</td>
<td>Cherson</td>
</tr>
<tr>
<td>Chilki</td>
<td>Chilki</td>
</tr>
<tr>
<td>Chirowka</td>
<td>Chirovka</td>
</tr>
<tr>
<td>Chischinzy</td>
<td>Chishinzy</td>
</tr>
<tr>
<td>Clausewitz</td>
<td>Clausewitz</td>
</tr>
<tr>
<td>Krakau</td>
<td>Cracow</td>
</tr>
<tr>
<td>Daschkukowka</td>
<td>Dashukovka</td>
</tr>
<tr>
<td>Dnjepr</td>
<td>Dnieper, River</td>
</tr>
<tr>
<td>Djnepropetrowsk</td>
<td>Dniepropetrovsk</td>
</tr>
<tr>
<td>Don</td>
<td>Don, River</td>
</tr>
<tr>
<td>Donetz</td>
<td>Donetz, River</td>
</tr>
<tr>
<td><a id="page_xxvi">Dshurshenzy</a></td>
<td>Dzhurshenzy</td>
</tr>
<tr>
<td>Galanin</td>
<td>Galanin</td>
</tr>
<tr>
<td>Gniloi Tikitsch</td>
<td>Gniloi Tikich, River</td>
</tr>
<tr>
<td>Gorodischtsche</td>
<td>Gorodishche</td>
</tr>
<tr>
<td>Gruskoje</td>
<td>Gruskoye</td>
</tr>
<tr>
<td>Ingul</td>
<td>Ingul, River</td>
</tr>
<tr>
<td>Ingulez</td>
<td>Ingulec, River</td>
</tr>
<tr>
<td>Irdyn-Sumpf</td>
<td>Irdyn Marshes</td>
</tr>
<tr>
<td>Iskrennoje</td>
<td>Iskrennoye</td>
</tr>
<tr>
<td>Kamenka</td>
<td>Kamenka</td>
</tr>
<tr>
<td>Kanew</td>
<td>Kanev</td>
</tr>
<tr>
<td>Kapitanowka</td>
<td>Kapitanovka</td>
</tr>
<tr>
<td>Charkow</td>
<td>Kharkov</td>
</tr>
<tr>
<td>Kiew</td>
<td>Kiev</td>
</tr>
<tr>
<td>Kirowograd</td>
<td>Kirovograd</td>
</tr>
<tr>
<td>Komarowka</td>
<td>Komarovka</td>
</tr>
<tr>
<td>Korosten</td>
<td>Korosten</td>
</tr>
<tr>
<td>Korsun</td>
<td>Korsun</td>
</tr>
<tr>
<td>Kowel</td>
<td>Kowel</td>
</tr>
<tr>
<td>Krassonssilka</td>
<td>Krassnossilka</td>
</tr>
<tr>
<td>Krementschug</td>
<td>Kremenchug</td>
</tr>
<tr>
<td>Krivoi Rog</td>
<td>Krivoi Rog</td>
</tr>
<tr>
<td>Kwitki</td>
<td>Kvitki</td>
</tr>
<tr>
<td>Lebedin</td>
<td>Lebedin</td>
</tr>
<tr>
<td>Lelekowka</td>
<td>Lelekovka</td>
</tr>
<tr>
<td>Lissjanka</td>
<td>Lissyanka</td>
</tr>
<tr>
<td>Mala Vyska</td>
<td>Mal-Viski</td>
</tr>
<tr>
<td>Mauerwald</td>
<td>Mauerwald</td>
</tr>
<tr>
<td>Medwin</td>
<td>Medvin</td>
</tr>
<tr>
<td><a id="page_xxvii">Mius</a></td>
<td>Mius, River</td>
</tr>
<tr>
<td>Morenzy</td>
<td>Morenzy</td>
</tr>
<tr>
<td>Mosyr</td>
<td>Mosyr</td>
</tr>
<tr>
<td>Nadlak</td>
<td>Nadlak</td>
</tr>
<tr>
<td>Nikopol</td>
<td>Nikopol</td>
</tr>
<tr>
<td>Now Greblja</td>
<td>Novaya Greblya</td>
</tr>
<tr>
<td>Nowgorodka</td>
<td>Novgorodka</td>
</tr>
<tr>
<td>Nowyj Mirgorod</td>
<td>Noviy Mirgorod</td>
</tr>
<tr>
<td>Nowo Ukrainka</td>
<td>Novo Ukrainka</td>
</tr>
<tr>
<td>Odessa</td>
<td>Odessa</td>
</tr>
<tr>
<td>Oktjabr</td>
<td>Oktyabr</td>
</tr>
<tr>
<td>Olschana</td>
<td>Olshana</td>
</tr>
<tr>
<td>Ossikowata</td>
<td>Ossikovata</td>
</tr>
<tr>
<td>Pantschewo</td>
<td>Panchevo</td>
</tr>
<tr>
<td>Pastorskoje</td>
<td>Pastorskoye</td>
</tr>
<tr>
<td>Perwomeisk</td>
<td>Pervomaisk</td>
</tr>
<tr>
<td>Progebischtsche</td>
<td>Pogrebishche</td>
</tr>
<tr>
<td>Potschapinzy</td>
<td>Potchapinzy</td>
</tr>
<tr>
<td>Pripjet</td>
<td>Pripet</td>
</tr>
<tr>
<td>Pruth</td>
<td>Pruth</td>
</tr>
<tr>
<td>Radomysl</td>
<td>Radomysl</td>
</tr>
<tr>
<td>Roshnatowka</td>
<td>Roshnatovka</td>
</tr>
<tr>
<td>Rostow</td>
<td>Rostov</td>
</tr>
<tr>
<td>Rotmistrow</td>
<td>Rotmistrov</td>
</tr>
<tr>
<td>Ryschanowka</td>
<td>Ryshanovka</td>
</tr>
<tr>
<td>Sarny</td>
<td>Sarny</td>
</tr>
<tr>
<td>Schandorowka</td>
<td>Shandorovka</td>
</tr>
<tr>
<td>Shaschkoff</td>
<td>Shashkov</td>
</tr>
<tr>
<td>Schewtschenkowsky</td>
<td>Shevchenkovskiy</td>
</tr>
<tr>
<td><a id="page_xxviii">Schpola</a></td>
<td>Shpola</td>
</tr>
<tr>
<td>Smela</td>
<td>Smela</td>
</tr>
<tr>
<td>Snamenka</td>
<td>Snamenka</td>
</tr>
<tr>
<td>Ssewerinka</td>
<td>Sseverinka</td>
</tr>
<tr>
<td>Starosselje</td>
<td>Staroselye</td>
</tr>
<tr>
<td>Swenigorodka</td>
<td>Svenigorodka</td>
</tr>
<tr>
<td>Tarnopol</td>
<td>Tarnopol</td>
</tr>
<tr>
<td>Tischkowka</td>
<td>Tichkovka</td>
</tr>
<tr>
<td>Uman</td>
<td>Uman</td>
</tr>
<tr>
<td>Werschina</td>
<td>Vershina</td>
</tr>
<tr>
<td>Winniza</td>
<td>Vinniza</td>
</tr>
<tr>
<td>Winograd</td>
<td>Vinograd</td>
</tr>
<tr>
<td>Wladimrowka</td>
<td>Vladimirovka</td>
</tr>
<tr>
<td>Wjasowok</td>
<td>Vyasovok</td>
</tr>
<tr>
<td>Jampol</td>
<td>Yampol</td>
</tr>
<tr>
<td>Jekaterinowka</td>
<td>Yekaterinovka</td>
</tr>
<tr>
<td>Jerki</td>
<td>Yerki</td>
</tr>
<tr>
<td>Saporoshje</td>
<td>Zaporozhye</td>
</tr>
<tr>
<td>Tschitomir</td>
<td>Zhitomir</td>
</tr>
</tbody></table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Maps.vue?71ceaa4d